import * as React from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';

interface CheckboxProps {
	id?: string;
	label?: string;
	value: boolean;
	size?: string;
	onChange?: (val: boolean) => void;
	className?: string;
	disabled?: boolean;
}

const Checkbox = forwardRef((props: CheckboxProps, ref: React.Ref<HTMLDivElement>) => {
	const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = event.target.checked;
		props.onChange?.(newValue);
	};

	const id = props.id ? props.id : uuid();
	const hasLabel = props.label !== undefined && props.label !== '';

	return (
		<Container className={`${hasLabel ? 'form-check' : ''} ${props.className ?? ''}`} ref={ref}>
			<input
				className={hasLabel ? 'form-check-input' : undefined}
				type="checkbox"
				id={id}
				checked={props.value}
				onChange={onChange}
				disabled={props.disabled === true}
			/>
			{hasLabel && (
				<label className="form-check-label" htmlFor={id}>
					{props.label}
				</label>
			)}
		</Container>
	);
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;

const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;

	label {
		margin: 0 0 0 0.5rem;
	}

	input {
		margin: 0;
	}
`;
